import React from 'react';
import styled from '@emotion/styled';
import { rem } from 'polished';
import { mixins, colors } from 'ech-components/src//core/styles/theme/default';
import { H3, Link } from 'ech-components/src/primitives';
import Spacer from 'ech-components/src/helpers/Spacer';

const StyledFunding = styled.article`
  display: flex;
  flex-direction: column;
  background: ${colors.primarySunYellow800};
  border-radius: ${rem(2)};
  padding: ${rem(40)};
  color: ${colors.secondarySoftPurple800};
  min-height: ${rem(300)};
  cursor: pointer;

  ${mixins.MQ('medium')} {
    height: 100%;
  }
`;

const StyledFundingMain = styled.div`
  flex: 1;
`;

const StyledTitle = styled(H3)`
  padding-right: ${rem(32)};
`;

const StyledLink = styled(Link)`
  margin-top: ${rem(10)};

  span {
    color: ${colors.secondarySoftPurple800};
  }

  svg path {
    stroke: ${colors.secondarySoftPurple800};
  }

  .m-richtext & {
    text-decoration: none;
  }
`;

const TeaserFunding = (props: TeaserFundingProps) => {
  const { title, teaser, href, moreLinkText } = props.data;

  return (
    <>
      <StyledFunding
        className={'item'}
        onClick={() => (window.location.href = href)}
      >
        <header>
          <StyledTitle>{title}</StyledTitle>
        </header>
        <Spacer space="gamma" />
        <StyledFundingMain>{teaser || ''}</StyledFundingMain>
        <Spacer space="alpha" />
        <footer>
          <StyledLink
            linkText={moreLinkText}
            link={{
              href,
              title: moreLinkText,
            }}
            iconBefore="AnimatedIconArrowRight"
            className="animate"
          />
        </footer>
      </StyledFunding>
    </>
  );
};

export type TeaserFundingProps = {
  data: {
    title: string;
    teaser?: string;
    slug?: string;
    node_locale?: string;
    href: string;
    moreLinkText: string;
  };
};

export default TeaserFunding;
